<template>
    <!-- // sub menu -->
    <Sticky
        :top="89"
        :show="89"
        stickyClass="scroll_top_nav"
        :stickyShowBefore="true"
        ref="sticky3"
    >
        <div class="nav-pill__wrapper sub-nav__child" v-if="isMobileRealTime">
            <div
                class="nav-pill"
                :class="{ selected: o.selected }"
                v-for="(o, index) in matchesSubmenus"
                :key="index"
                @click="selectChildMenu(o, matchesSubmenus)"
            >
                {{ $t(o.name) }}
            </div>
        </div>
    </Sticky>

    <div
        class="display-flex team-match-container"
        :class="{
            'has-space': !isMobile,
        }"
    >
        <div
            :class="{
                'team-overview-container': !isMobile,
                'team-content-container': true,
            }"
        >
            <slot name="header" />
            <template v-if="!isMobileRealTime">
                <div class="team-container-title">
                    {{ $t("MATCHES") }}
                </div>
                <div
                    class="nav-pill__wrapper sub-nav__child team-match-fixture-btn"
                >
                    <div
                        class="nav-pill btn-aspn-default"
                        :class="{ selected: o.selected }"
                        v-for="(o, index) in matchesSubmenus"
                        :key="index"
                        @click="selectChildMenu(o, matchesSubmenus)"
                    >
                        {{ $t(o.name) }}
                    </div>
                </div>
            </template>
            <!-- // competition options -->
            <Picker
                ref="competitionPicker"
                v-model:show="showPicker"
                :list="competitionList"
                @cancel="showPicker = false"
                @confirm="handleConfirmPicker"
                @selected="handleCompetitionSelect"
                title="SELECT_COMPETITION"
                :selected="competitionSelect"
                :columnsFieldNames="{ text: 'leagueName', value: 'leagueId' }"
                :content="['logo', 'leagueName', '']"
            >
                <template #prefix="{ option }">
                    <Icon
                        :logoUrl="option?.logo"
                        o
                        class="mr-05rem"
                        v-if="option.leagueKey !== null"
                    ></Icon>
                    <IconMode v-else>
                        <template #default="{ index }">
                            <img
                                src="@static/images/icons/aspn_icon/team/all_competition.png"
                                v-if="
                                    ['lightWeb', 'lightWebapp'].includes(index)
                                "
                                class="mr-05rem all_competition_icon"
                            />
                            <img
                                src="@static/images/icons/aspn_icon/team/all_competition_dark.png"
                                v-else-if="
                                    ['darkWeb', 'darkWebapp'].includes(index)
                                "
                                class="mr-05rem all_competition_icon"
                            />
                        </template>
                    </IconMode>
                </template>
                <template #mobileButton>
                    <div
                        class="team-competition-selected-wrapper mt-1rem mb-05rem"
                        v-if="competitionSelect.selectedLangObj !== null"
                    >
                        <button
                            class="news-language__selected-pill btn-aspn-default"
                            @click="openPicker()"
                        >
                            <div
                                class="news-language__selected-name display-flex-align-center"
                            >
                                <template
                                    v-if="
                                        competitionSelect
                                            ?.selectedCompetitionObj?.leagueKey
                                    "
                                >
                                    <Icon
                                        :logoUrl="
                                            competitionSelect
                                                .selectedCompetitionObj.logo
                                        "
                                        o
                                        class="mr-05rem"
                                    ></Icon>
                                    {{
                                        competitionSelect.selectedCompetitionObj
                                            .leagueName
                                    }}
                                </template>
                                <template v-else>
                                    <IconMode>
                                        <template #default="{ index }">
                                            <img
                                                src="@static/images/icons/aspn_icon/team/all_competition.png"
                                                v-if="
                                                    [
                                                        'lightWeb',
                                                        'lightWebapp',
                                                    ].includes(index)
                                                "
                                                class="mr-05rem all_competition_icon"
                                            />
                                            <img
                                                src="@static/images/icons/aspn_icon/team/all_competition_dark.png"
                                                v-else-if="
                                                    [
                                                        'darkWeb',
                                                        'darkWebapp',
                                                    ].includes(index)
                                                "
                                                class="mr-05rem all_competition_icon"
                                            />
                                        </template>
                                    </IconMode>
                                    {{ $t("ALL_COMPETITIONS") }}
                                </template>
                            </div>
                            <div
                                class="news-language__list-caret"
                                :class="{
                                    active: competitionSelect.isShowList,
                                }"
                            >
                                <SvgIcon icon="c.header.newsCaret" />
                            </div>
                        </button>
                    </div>
                </template>
            </Picker>

            <div class="display-flex-sb">
                <!-- <div
          class="news-language__selection-wrapper team-competition-selected-wrapper"
          v-if="competitionSelect.selectedLangObj !== null"
          @mouseover="handleShowCompetitionOptionlist('enter')"
          @mouseleave="handleShowCompetitionOptionlist('leave')">
          <div
            class="news-language__selected-pill "
            
          >
            <div class="news-language__selected-name display-flex-align-center">
              <template v-if="competitionSelect?.selectedCompetitionObj?.leagueKey">
                <Icon :logoUrl="competitionSelect.selectedCompetitionObj.logo" o class="mr-05rem"></Icon>
                {{ competitionSelect.selectedCompetitionObj.leagueName }}
              </template>
              <template v-else>
                <IconMode>
                  <template #default="{ index }">
                    <img src="@static/images/icons/aspn_icon/team/all_competition.png" v-if="['lightWeb','lightWebapp'].includes(index)" class="mr-05rem all_competition_icon" />
                    <img src="@static/images/icons/aspn_icon/team/all_competition_dark.png" v-else-if="['darkWeb','darkWebapp'].includes(index)" class="mr-05rem all_competition_icon" />
                  </template>
                </IconMode> 
                {{ $t('ALL_COMPETITIONS') }}
              </template>
            </div>
            <div class="news-language__list-caret" :class="{ active: competitionSelect.isShowList }">
              <SvgIcon icon="c.header.newsCaret" />
            </div>
          </div>
          <div class="team-competition-list-wrapper news-language-list__wrapper" :class="{ active: competitionSelect.isShowList }">
            <div
              class="news-language-list__container"
              v-for="(o, index) in compeititonList"
              :key="index"
              :class="{ selected: o.leagueKey === competitionSelect.selectedCompetitionObj?.leagueKey }"
              @click="handleCompetitionSelect(o)"
            >
              <div class="news-language-list__name display-flex-align-center">
                <Icon :logoUrl="o?.logo" o class="mr-05rem" v-if="o.leagueKey !== null"></Icon>
                <IconMode v-else>
                  <template #default="{ index }">
                    <img src="@static/images/icons/aspn_icon/team/all_competition.png" v-if="['lightWeb','lightWebapp'].includes(index)" class="mr-05rem all_competition_icon" />
                    <img src="@static/images/icons/aspn_icon/team/all_competition_dark.png" v-else-if="['darkWeb','darkWebapp'].includes(index)" class="mr-05rem all_competition_icon" />
                  </template>
              </IconMode>
                {{ o.leagueName }}
              </div>
              <div class="news-language-list__tick" :class="{ selected: o.leagueKey === competitionSelect.selectedCompetitionObj?.leagueKey }"></div>
            </div>
          </div>
        </div> -->
                <div class="block"></div>
            </div>

            <!-- <template v-else>
        <div class="match-table__header">
            <div class="nav-pill__wrapper league-matchtabs__wrapper">
              <div
                v-if="subLeagueList.length === 1"
                id="subLeagueId"
                class="nav-pill"
                :class="[
                  { selected: currentSubLeague.colored },
                  currentSubLeague.colored
                    ? 'mobile-select-container-dropdown-active'
                    : 'mobile-select-container-dropdown-inactive',
                ]">
                {{ $t(currentSubLeague.subLeagueName) }}
              </div>
            </div>
          </div>
      </template>
       -->

            <MatchContent
                ref="matchContentChild"
                class="match-content__wrapper mt-m"
                style="min-height: 15rem"
                :params="{
                    selectedCurrentChildMenuIndex:
                        selectedCurrentChildMenuIndex,
                }"
                @changeMatchContentEvent="changeMatchContentEvent"
                type="team"
            ></MatchContent>
        </div>
        <TeamMatchTable v-if="!isMobile" ref="teamMatchTable" />

        <!-- <div class="match-table">
      <div>
        <div class="match-table__header">
          <div>{{ $t("STANDINGS") }}</div>
          <div class="nav-pill__wrapper">
            <div
              class="nav-pill"
              :class="{ selected: o.selected }"
              v-for="(o, index) in tableTabs"
              :key="index"
              @click="selectTableTabs(o)"
            >
              {{ $t(o.name) }}
            </div>
          </div>
        </div>

        <div v-show="currentTableTabs === 'total'">
          <MatchTable
            :isShowTabs="false"
            :type="'total'"
            :matchTableListData="matchTableList"
          ></MatchTable>
        </div>
        <div v-show="currentTableTabs === 'home'">
          <MatchTable
            :isShowTabs="false"
            :type="'home'"
            :matchTableListData="matchTableList"
          ></MatchTable>
        </div>
        <div v-show="currentTableTabs === 'away'">
          <MatchTable
            :isShowTabs="false"
            :type="'away'"
            :matchTableListData="matchTableList"
          ></MatchTable>
        </div>
      </div>
    </div> -->
        <!-- @changeMatchContentEvent="" -->
        <!-- <MatchContent  ref="matchContentChild"  :isStatusWidthAuto="true" :isShowStatusAtTop="true" ></MatchContent> -->
    </div>
</template>

<script>
import MatchContent from "@/components/MatchContent3.vue";
import MatchTable from "@/components/match/football/TableTeam.vue";
import TeamMatchTable from "./Table.vue";
import moment from "moment";
import { DatePicker } from "@/lib/v-calendar";
import config from "@/js/config.js";
import MobileSelect from "mobile-select"; //"@/lib/mobile-select"
import Picker from "@/components/picker/Picker.vue";

import { mapGetters, mapActions } from "vuex";

const DATE = "DATE";
let hideToggleElement;
let hideToggleTarget;
let mobileSelectSubLeague; // defined mobile select dropdown component for subLeague
export default {
    components: {
        MatchContent,
        DatePicker,
        MatchTable,
        TeamMatchTable,
        Picker,
    },
    data() {
        return {
            showPicker: false,
            displayDateFormat: config.displayDateFormat,
            matchContentInterval: null,
            montlyCalender: {
                date: DATE,
                dateValue: "",
                selected: false,
                isFirstime: false,
            },
            montlyCalenderModel: "",
            selectedDate: {}, //date
            isShowClearBtn: false, //date
            matchOptions: [
                {
                    name: "UPCOMING",
                    selected: false,
                    type: 1,
                },
                {
                    name: "MOST_RECENT",
                    selected: false,
                    type: 2,
                },
            ],
            tableTabs: [
                {
                    name: "ALL",
                    id: "total",
                    selected: true,
                },
                {
                    name: "HOME",
                    id: "home",
                    selected: false,
                },
                {
                    name: "AWAY",
                    id: "away",
                    selected: false,
                },
            ],
            currentTableTabs: "total", //default show first 1
            currentChildMenus: [],
            matchesSubmenus: [
                {
                    name: "FIXTURES",
                    idKey: "fixtures",
                    id: 1,
                    selected: true,
                },
                {
                    name: "RESULTS",
                    idKey: "results",
                    id: 2,
                    selected: false,
                },
            ],
            selectedCurrentChildMenuIndex: 1,
            selectedCurrentChildMenuIndexForAllCompetition: null, // use to verify which time need init

            competitionSelect: {
                selectedCompetitionObj: null,
                isShowList: false,
                msInstance: null,
            },
            competitionList: [],
            subLeagueList: [
                //subleague list
                {
                    subLeagueName: "ALL_COMPETITIONS",
                    subLeagueId: "",
                    selected: false,
                },
            ],
            currentSubLeague: {
                subLeagueName: "",
                isShowDropdown: false,
                colored: false,
            },
            teamMatchList: [],
        };
    },
    created() {
        this.teamKey = this.$route.params.teamKey;
    },
    beforeUnmount() {
        clearInterval(this.matchContentInterval);
    },
    mounted() {
        this.init();
    },
    watch: {
        currentLocale: {
            deep: true,
            handler(newVal, oldVal) {
                this.init();
                // this.getLeagueListForRankingTable(newVal.leagueIdList);
            },
        },
        $route() {
            if (this.montlyCalender.dateValue != "") {
                this.montlyCalender.date = moment(
                    this.montlyCalender.dateValue
                ).format(this.displayDateFormat); // when change multilanguage options translate the display date also
            }
        },
        "$route.params.teamKey"(newVal) {
            if (newVal !== undefined) {
                this.$refs.teamMatchTable.init();
                this.init();
            }
        },
        montlyCalenderModel: {
            deep: true,
            handler(newVal, oldVal) {
                if (newVal !== DATE) {
                    if (typeof hideToggleElement !== "undefined") {
                        setTimeout(
                            () => hideToggleElement({ ref: hideToggleTarget }),
                            500
                        ); // noob fix vcalendar bug (somethimes dont close the calendar automatic);
                    }

                    this.montlyCalender.date = moment(
                        newVal === null ? oldVal : newVal
                    ).format(this.displayDateFormat);
                    this.montlyCalender.dateValue =
                        newVal === null ? oldVal : newVal;
                    this.montlyCalenderModel =
                        newVal === null ? oldVal : newVal;

                    //this.isShowClearBtn = true;

                    this.montlyCalender.selected = true;
                    this.handleResetMatchOptions();

                    // this.getFixtureByLeagueData();
                }
            },
        },
    },
    computed: {
        ...mapGetters(["currentLocale", "isMobile", "isMobileRealTime"]),
    },

    methods: {
        init() {
            this.setTeamKey();
            this.getAllCompetitionListData();
            this.handleMatchOptions(this.matchOptions[0], true); // default call upcomming data, and get pass subLeagueId from querystring

            this.commitParamsToMatchContent();
            this.commitParamsToMatchContentIntervel();

            // let params = {
            //   teamId: this.teamKey,
            //   isCallInterval: false,
            // };
            // this.$refs.matchContentChild.getMatchListByTeamData(params);
        },

        setTeamKey() {
            this.teamKey = this.$route.params.teamKey;
        },

        commitParamsToMatchContentIntervel() {
            if (this.matchContentInterval) {
                clearInterval(this.matchContentInterval);
            }
            this.matchContentInterval = setInterval(() => {
                this.commitParamsToMatchContentInterval();
            }, 15000);
        },

        commitParamsToMatchContentInterval() {
            let params = {
                teamId: this.teamKey,
                type: this.selectedCurrentChildMenuIndex,
                isCallInterval: true,
            };
            this.$refs.matchContentChild.getMatchListByTeamData(params);
        },

        commitParamsToMatchContent() {
            let params = {
                teamId: this.teamKey,
                type: this.selectedCurrentChildMenuIndex,
                isCallInterval: false,
            };
            this.$refs.matchContentChild.getMatchListByTeamData(params);
        },

        selectChildMenu(o, menuList) {
            // this.competitionList = [];
            // this.getAllCompetitionListData()
            menuList.forEach((x) => {
                x.selected = false;
            });
            o.selected = true;
            if (menuList !== this.matchesSubmenus) {
                this.currentTableTabs = o.idKey;
            } else if (menuList === this.matchesSubmenus) {
                this.selectedCurrentChildMenuIndex = o.id;
                let params = {
                    teamId: this.teamKey,
                    isCallInterval: false,
                };

                this.competitionSelect.selectedCompetitionObj = {
                    leagueKey: null,
                };

                switch (o.idKey) {
                    case "fixtures": //matches
                        // this.handleReset();
                        params["type"] = 1;
                        this.$refs.matchContentChild.getMatchListByTeamData(
                            params
                        );
                        this.$refs.sticky3.checking(3);
                        break;
                    case "results": //past seasons
                        // this.handleReset();

                        params["type"] = 2;
                        this.$refs.matchContentChild.getMatchListByTeamData(
                            params
                        );
                        this.$refs.sticky3.checking(4);
                        break;
                }
            }
        },

        // Mobile - set 'Matches > Results' filter pill
        setResultsFilterPill(toShow) {
            this.mobileResultsSeasonFilter.show = toShow;
        },

        monthlyCalendarHandle(e, date, toggle, hideToggle) {
            toggle({ ref: e.target });

            hideToggleTarget = e.target;
            hideToggleElement = hideToggle;
        },

        dateSelected(e, date, toggle) {
            this.selected = date;
            toggle({ ref: e.target });
        },

        handleClearDate() {
            this.montlyCalender.selected = false;
            this.isShowClearBtn = false;
            this.montlyCalender.date = DATE;
            this.montlyCalender.dateValue = "";
        },

        handleMatchOptions(o, isFirstTimeLoadData) {
            this.matchOptions.forEach((x) => {
                x.selected = false;
            });
            o.selected = true;
            this.type = o.type;

            this.handleClearDate();

            if (isFirstTimeLoadData) {
                this.currentSubLeague.subLeagueId =
                    this.subLeagueList[0].subLeagueId;
                this.currentSubLeague.subLeagueName =
                    this.subLeagueList[0].subLeagueName;
            }

            // this.getFixtureByLeagueData();
        },

        handleResetMatchOptions() {
            this.matchOptions.forEach((x) => {
                x.selected = false;
            });
            this.type = "";
        },

        handleShowCompetitionOptionlist(action) {
            if (action === "enter") {
                this.competitionSelect.isShowList = true;
            } else {
                this.competitionSelect.isShowList = false;
            }
        },
        handleCompetitionSelect(o) {
            this.competitionSelect.isShowList = false;
            this.setSelectedCompeition(o);
        },
        setSelectedCompeition(o = null) {
            let params = {
                teamId: this.teamKey,
                type: this.selectedCurrentChildMenuIndex,
                leagueId: o.leagueId,
                isCallInterval: true,
            };
            if (o.leagueKey === null) {
                this.competitionSelect.selectedCompetitionObj = {
                    leagueKey: null,
                };
            } else {
                this.competitionSelect.selectedCompetitionObj = o;
            }
            this.$refs.matchContentChild.getMatchListByTeamData(params);
        },
        async getAllCompetitionListData() {
            let mobileSelectData = [];
            let mobileObj = {
                id: "",
                value: "",
            };
            let params = {
                teamId: this.teamKey,
            };

            // const result = await this.getAllCompetitionList(params);
            const result = { result: [] };

            if (result.result.length != 0) {
                this.subLeagueList.length = 1; //reset subLeagueList array and only keep first array;
                mobileObj.id = this.subLeagueList[0].subLeagueId;
                mobileObj.value = this.$i18n.t(
                    this.subLeagueList[0].subLeagueName
                );
                mobileSelectData.push(mobileObj);

                result.result.forEach((x) => {
                    // (Mobile) insert subleague data to mobile select
                    let mobileObj = {
                        id: "",
                        value: "",
                    };
                    mobileObj.id = x.subLeagueId;
                    mobileObj.value = x.subLeagueName;

                    mobileSelectData.push(mobileObj);

                    x.selected = false;

                    // (Dekstop) insert subleague data to desktop select
                    this.subLeagueList.push(x);

                    // selected data
                    if (x.subLeagueId === this.subLeagueId) {
                        let isFirstTimeLoadData = true;
                        this.handleSubLeagueDropdown(x, isFirstTimeLoadData);
                    }
                });

                //(Mobile) initial mobile subleague select
                if (this.isMobile) {
                    this.$nextTick(() => {
                        //store vue js this to that
                        let that = this;

                        let triggerId = "#subLeagueId";
                        let title = this.$i18n.t("SELECT_GROUP");
                        let ensureBtnText = this.$i18n.t("DONE");
                        let cancelBtnText = this.$i18n.t("CANCEL");

                        let ensureBtnColor =
                            "var(--color-text-primary-default)";
                        let titleBgColor = "#F0F0F0";

                        if (mobileSelectSubLeague) {
                            mobileSelectSubLeague.destroy();
                            // return
                        }
                        mobileSelectSubLeague = new MobileSelect({
                            trigger: triggerId,
                            triggerDisplayData: false,
                            title: title,
                            ensureBtnText: ensureBtnText,
                            cancelBtnText: cancelBtnText,
                            ensureBtnColor: ensureBtnColor,
                            titleBgColor: titleBgColor,

                            wheels: [
                                {
                                    data: mobileSelectData,
                                },
                            ],

                            callback: function (indexArr, data) {
                                that.currentSubLeague.subLeagueName =
                                    data[0].value;
                                that.currentSubLeague.subLeagueId = data[0].id;
                                if (that.currentSubLeague.subLeagueId === "") {
                                    that.currentSubLeague.colored = false;
                                } else {
                                    that.currentSubLeague.colored = true;
                                }
                                //	alert ("ss")
                                that.getFixtureByLeagueData();
                            },
                        });
                        if (
                            this.subLeagueId === null ||
                            typeof this.subLeagueId === "undefined"
                        ) {
                            mobileSelectSubLeague.locatePosition(0, 0);
                        } else if (!that.isResetMatchOptions) {
                            for (let i = 0; i < mobileSelectData.length; i++) {
                                if (
                                    mobileSelectData[i].id === this.subLeagueId
                                ) {
                                    that.currentSubLeague.subLeagueName =
                                        mobileSelectData[i].value;

                                    that.currentSubLeague.colored = true;
                                    that.isResetMatchOptions = true;
                                    mobileSelectSubLeague.locatePosition(0, i);
                                }
                            }
                        }
                    });
                }
            }
        },
        changeMatchContentEvent(matchList) {
            let compeititonList = [];
            if (
                this.selectedCurrentChildMenuIndex !==
                this.selectedCurrentChildMenuIndexForAllCompetition
            ) {
                this.teamMatchList = matchList;
                const idExists = [];
                for (var index in this.teamMatchList) {
                    let item = JSON.parse(
                        JSON.stringify(this.teamMatchList[index])
                    );

                    delete item.matchList;
                    if (!idExists.includes(item.leagueId)) {
                        idExists.push(item.leagueId);
                        compeititonList.push(item);
                    }
                }
                compeititonList.unshift({
                    isFavLeague: true,
                    country: "All",
                    countryKey: "all",
                    rootFlag: true,
                    leagueKey: null,
                    leagueId: null,
                    countryDisplayName: this.$t("ALL_COMPETITIONS"),
                    leagueName: this.$t("ALL_COMPETITIONS"),
                    selected: null,
                    logo: "",
                });
                this.competitionList = compeititonList;
                this.selectedCurrentChildMenuIndexForAllCompetition =
                    this.selectedCurrentChildMenuIndex;

                let currentLeagueId =
                    this.competitionSelect.selectedCompetitionObj?.leagueId;
                let isExistsId = false;
                for (var index in compeititonList) {
                    let id = compeititonList[index].leagueId;
                    if (id === currentLeagueId) {
                        isExistsId = true;
                        break;
                    }
                }
                if (!isExistsId) {
                    this.competitionSelect.selectedCompetitionObj = {
                        leagueKey: null,
                    };
                }
            }
        },
        handleConfirmPicker(option) {
            // selectedValues[0]: value
            // selectedOptions[0]: obj
            // selectedIndexes[0]: index

            let o = option.selectedOptions[0];
            let index = option.selectedIndexes[0];
            let params = {
                teamId: this.teamKey,
                type: this.selectedCurrentChildMenuIndex,
                leagueId: o.leagueId,
                isCallInterval: true,
            };
            if (o.leagueKey === null) {
                this.competitionSelect.selectedCompetitionObj = {
                    leagueKey: null,
                };
                this.competitionSelect.selectedIndex = 0;
            } else {
                this.competitionSelect.selectedCompetitionObj = o;
                this.competitionSelect.selectedIndex = index;
            }
            if (this.competitionSelect.selectedCompetitionObj.leagueId) {
                params.leagueId =
                    this.competitionSelect.selectedCompetitionObj.leagueId;
            }
            this.$refs.matchContentChild.getMatchListByTeamData(params);
            this.showPicker = false;
        },
        openPicker() {
            if (!this.isLoading) {
                this.showPicker = !this.showPicker;
            }
        },
    },
};
</script>

<style scoped>
.team-match-container {
    gap: 24px;
}
.team-content-container {
    width: 100%;
}
.team-overview-container {
    background: var(--color-background-default-secondary);
    padding: var(--size-space-400);
    letter-spacing: 0.64px;
    /* border-radius: 0 0 16px 16px; */
    width: 100%;
    border-radius: 16px;
}
.team-container-title {
    color: var(--color-text-default-default);

    /* Body Strong */
    font-size: var(--typography-body-size-large);
    font-style: normal;
    font-family: var(--weight-600);
    line-height: 140%; /* 22.4px */
    letter-spacing: 0.64px;
    margin-bottom: 1rem;
}
.nav-pill {
    font-size: 16px;
}
.nav-pill__wrapper {
    margin-right: 0;
    padding: 8px 0;
    background-color: var(--color-background-default-secondary);
    letter-spacing: 0.64px;
}
.sub-nav__child {
    padding-right: 0;
}
.sub-nav__child .nav-pill {
    width: 100%;
    color: var(--color-text-default-default);
    padding: 8px;
    border: 1px solid var(--color-border-default-default);
}
.sub-nav__child .nav-pill:last-child {
    margin-right: 0 !important;
}
.match-content__wrapper {
    width: 100%;
}
.match-table {
    background: var(--color-background-default-secondary);
    border-radius: 16px;
    padding: 16px;
    box-sizing: border-box;
    width: 100%;
}
.match-table__header .nav-pill__wrapper {
    margin-top: 16px;
}
.match-table__header .nav-pill__wrapper .nav-pill {
    border: 1px solid var(--color-border-default-default);
    border-radius: var(--size-radius-600);
    color: var(--color-text-default-default);
}
.match-table__header .nav-pill__wrapper .nav-pill.selected {
    border: 1px solid var(--bg-selected) !important;
}
@media(max-width: 768px) {
    /* for test */
    .match-content__wrapper {
        width: 100%;
        padding: 0 8px;
        margin-top: 0;
        box-sizing: border-box;
        margin-bottom: 62px;
    }
    .team-container {
        width: 100%;
        padding: 0;
    }
    .team-overview-container {
        border-radius: 8px;
        background-color: transparent;
        padding: 16px 0;
    }
    .nav-pill__wrapper {
        padding: 8px;
        font-size: 13px;
        border-bottom: 1px solid var(--color-border-default-default);
    }
    .match-table__header .nav-pill__wrapper {
        margin-top: 0;
    }
    .match-table__header .nav-pill__wrapper .nav-pill {
        width: 100%;
        font-size: 14px;
        letter-spacing: 0.64px;
    }
    .nav-pill {
        font-size: 13px;
    }
}
</style>

<style scoped>
.flex-shrink-0 {
    flex-shrink: 0;
}
.news-language__selection-wrapper {
    position: relative;
    display: flex;
    border-radius: 16px;
    margin-top: 8px;
    margin-bottom: 16px;
}
.news-language__selected-pill {
    display: flex;
    justify-content: space-between;
    align-items: center;

    box-sizing: border-box;
    width: auto;
    border: 1px solid var(--color-border-default-default);
    border-radius: 1.5rem;
    padding: 8px 24px;
    font-size: 16px;
    font-family: var(--weight-600);
    cursor: pointer;
    letter-spacing: 0.64px;
}
.news-language__selected-pill .news-language__list-caret {
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
    transition: all 0.3s;
}
.news-language__selected-pill .news-language__list-caret.active {
    transform: rotateX(180deg);
}
.news-language-list__wrapper {
    position: absolute;
    top: 105%;
    z-index: 2;
    background: var(--color-background-default-secondary);
    border-radius: 0.7rem;
    min-width: 15.5rem;
    transform: scale(0);
    transform-origin: 50% 0;
    transition: all 0.3s;
    padding: 0.5rem;
    border: 1px solid var(--color-border-default-default);
}
.news-language-list__wrapper.active {
    transform: scale(1);
}
.news-language-list__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    margin-bottom: 0.375rem;
    border-radius: 0.3rem;
    cursor: pointer;
    font-size: 16px;
    font-family: var(--weight-600);
}
.news-language-list__container:last-child {
    margin-bottom: 0;
}
.news-language-list__container:hover,
.news-language-list__container.selected {
    background: var(--primary-500);
    color: var(--color-button-active) !important;
}
.news-language-list__name {
    font-size: 16px;
    font-family: var(--weight-600);
}
.news-language-list__tick {
    width: 1rem;
    height: 1rem;
}
.news-language-list__tick.selected {
    background: url("../../../../../static/images/icons/icon_tick_selected.png")
        center/cover no-repeat;
    background-size: 12px 10px;
}
.all_competition_icon {
    width: 24px;
    height: 24px;
}
.nav-pill svg path {
    fill: var(--color-text-default-default);
}
.team-competition-selected-wrapper .news-language__selected-pill {
    background-color: var(--color-background-default-secondary);
    border: 1px solid var(--color-border-default-default);
    color: var(--color-text-default-default);
}
.news-language-list__container:hover .news-language-list__name,
.news-language-list__container.selected .news-language-list__name {
    color: var(--color-button-active);
}

.team-competition-list-wrapper .news-language-list__name {
    color: var(--color-text-default-default);
}
.news-language__selection-wrapper {
    margin-bottom: 0;
}
.team-match-fixture-btn {
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px dashed var(--color-border-default-default);
}

@media(max-width: 768px) {
    /* for test */
    .news-language__selected-pill {
        width: calc(100% - 16px);
        justify-content: center;
        margin: 0 8px;
        font-size: 13px;
    }
    .news-language__selection-wrapper {
        width: 100%;
    }
    .news-language-list__wrapper {
        width: calc(100% - 16px);
        left: 8px;
        box-sizing: border-box;
    }
    .scroll_top_nav {
        top: 93px;
        border-bottom: 1px solid var(--color-border-default-default);
        width: 100%;
        background: var(--color-background-default-secondary);
        left: 0;
    }
}
</style>
